module.exports = __webpack_public_path__ + "img/sq5m_feature_02.95b5a5ba.jpg";